import { render, staticRenderFns } from "./novel_long_series_popup.vue?vue&type=template&id=21834332&scoped=true"
import script from "./novel_long_series_popup.vue?vue&type=script&lang=js"
export * from "./novel_long_series_popup.vue?vue&type=script&lang=js"
import style0 from "./novel_long_series_popup.vue?vue&type=style&index=0&id=21834332&prod&lang=css"
import style1 from "./novel_long_series_popup.vue?vue&type=style&index=1&id=21834332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21834332",
  null
  
)

export default component.exports